"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformationStyled = void 0;
exports.InformationStyled = styled.div `
&.octo {
  display: flex;
  flex-flow: row nowrap;
  gap: 0.5em;
  align-items: stretch;
  justify-content: stretch;

  >.icon {
    width: 1.25em;
    min-width: 1.25em;
    height: 1.25em;
    min-height: 1.25em;
  }

  >.info {
    display: flex;
    flex-flow: column nowrap;
    gap: 0.25em;
    align-items: stretch;
    justify-content: stretch;

    >.title {
      font-weight: 600;
    }

    >.content {
      max-width: 12em;
    }
  }

  &.wrappable {
    >.info {
      >.content {
        word-break: break-all;
      }
    }
  }
}
`;
//# sourceMappingURL=Information.styled.js.map